import React from 'react';
import LostScreen from "../screens/support/LostScreen.js";
const create = molten => {
  return {
    id: 'molten.UnknownRoute',
    matches: {
      client: 'Main'
    },
    exact: false,
    path: '',
    render: ({
      match,
      location,
      history
    }) => {
      return /*#__PURE__*/React.createElement(LostScreen, null);
    }
  };
};
export default {
  create
};